import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable, shareReplay } from 'rxjs';
import { AyaSchoolDataByLanguage, DestinationFilter } from '../../models';
import { FilterService } from '../../services/filter.service';
import { SharedDataStore } from '../../store';
import { AyaDataComponent } from '../aya-data/aya-data.component';
import { PriceListPanelComponent } from '../price-list-panel/price-list-panel.component';
import { AyaSchoolService } from '../../services/aya-school.service';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-academic-year-abroad',
  imports: [PriceListPanelComponent, AsyncPipe, AyaDataComponent],
  templateUrl: './academic-year-abroad.component.html',
  styleUrls: ['./academic-year-abroad.component.scss'],
})
export class AcademicYearAbroadComponent implements OnInit {
  ayaSchoolTables$: Observable<AyaSchoolDataByLanguage[] | undefined>;
  filters$: Observable<DestinationFilter[]> | undefined;

  private filtersSubject = new BehaviorSubject<DestinationFilter[]>([]);
  private selectedFilters$ = this.filtersSubject.asObservable();

  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly filterService = inject(FilterService);
  private readonly ayaSchoolService = inject(AyaSchoolService);

  ngOnInit() {
    const ayaSchoolTables$ = this.sharedDataStore.ayaSchoolTables$.pipe(shareReplay(1));
    this.filters$ = ayaSchoolTables$.pipe(map((ayaSchoolTables) => this.filterService.getAyaDestinationFilters(ayaSchoolTables) || []));
    this.initializeFilteredAyaSchools(ayaSchoolTables$);
  }

  filterAyaSchools(filters: DestinationFilter | DestinationFilter[]) {
    this.filtersSubject.next(Array.isArray(filters) ? filters : [filters]);
  }

  private initializeFilteredAyaSchools(ayaSchoolData$: Observable<AyaSchoolDataByLanguage[]>) {
    this.ayaSchoolTables$ = combineLatest([ayaSchoolData$.pipe(map((data) => data ?? [])), this.selectedFilters$]).pipe(
      map(([schoolsByLanguage, selectedFilters]) => {
        if (!schoolsByLanguage.length) {
          return [];
        }

        if (!selectedFilters?.length) {
          return schoolsByLanguage;
        }

        // for each language, filter schools by selected countries and schools
        return this.ayaSchoolService.filterSchools(schoolsByLanguage, selectedFilters);
      }),
    );
  }
}
